module.exports = __webpack_public_path__ + "static/img/folder.57d5eb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Action/folder.png
// module id = 16
// module chunks = 0